"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ContainerLogic_1 = require("./shared/ContainerLogic");
// This is a default container used when no other container can be rendered
const NoSkin = (props, ref) => {
    // TODO - this is a temporary patch because TB is not passing `meshProps` for some components (SITE_PAGES)
    if (!props.meshProps) {
        // eslint-disable-next-line no-console
        console.warn(`Container_NoSkin.skin: Warning! meshProps are missing for component id: ${props.id}`);
    }
    const patchedMeshProps = props.meshProps || {
        wedges: props.wedges || [],
        rotatedComponents: props.rotatedComponents || [],
    };
    return (React.createElement(ContainerLogic_1.ContainerLogic, Object.assign({ meshProps: patchedMeshProps }, props, { ref: ref, renderSlot: ({ containerChildren }) => containerChildren })));
};
exports.default = React.forwardRef(NoSkin);
//# sourceMappingURL=Container.js.map